<template>
	<div class="layer-project" data-project-name="lg-archive">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">LG Chem <br />Digital Archive</h1>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						LG화학의 역사적 기록물을 디지털 기록으로 보존 관리하는 사이트의 개편
						작업을 진행하였습니다.
					</p>
					<div class="project-overview-diagram">
						<div class="diagram01">
							<div class="diagram-box">
								<div class="item01">Enhanced<br />Search<br />Capabilities</div>
							</div>
							<div class="diagram-box">
								<div class="item02">Improved<br />UI/UX Design</div>
								<div class="item03">User<br />Convenience</div>
							</div>
							<div class="diagram-box">
								<div class="item04">LG<br />Digital Archive</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<!-- section01 : mobile-web [s] -->
			<section class="section section01">
				<div class="inner-section">
					<div class="information-area">
						<strong class="project-subtit">PC Web</strong>
						<p class="sub-text">
							검색기능의 강화 및 사용자의 검색목적에 맞는 직 관적인 구조설계로
							편의성을 제공합니다.<br />
							사료가 주는 어렵고 딱딱한 느낌을 다채로운 콘텐츠의 구성으로
							사용자가 쉽고 편안하게 접근 할 수 있도록 구성하였습니다.
						</p>
					</div>
					<div class="img-box">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-archive/pc-web@m.png"
						/>
					</div>
					<div class="img-abs">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-archive/pc-web02@m.png"
						/>
					</div>
				</div>
			</section>
			<!-- section01 : mobile-web [e] -->
			<!-- section02 [s] -->
			<section class="section section02">
				<div class="inner-section">
					<div class="img-box">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-archive/pc-web03@m.png"
						/>
					</div>
				</div>
			</section>
			<!-- section02 : [e] -->
			<!-- section03 : [s] -->
			<section class="section section03">
				<div class="inner-section">
					<div class="img-box">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-archive/pc-web04@m.png"
						/>
					</div>
				</div>
			</section>
			<!-- section03 : [e] -->
			<!-- section04 : project identity [s]-->
			<section class="section section04">
				<div class="inner-section">
					<div class="point-area">
						<div class="log-font-box">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lg-archive/font-lg-smart@m.png"
								/>
							</div>
						</div>
						<div class="point-font-and-color">
							<div class="point-font">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lg-archive/point-font@m.png"
								/>
							</div>
							<ul class="point-color">
								<li class="color01">#b41131</li>
								<li class="color02">#333333</li>
								<li class="color03">#666666</li>
								<li class="color04">#474e5a</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
			<!-- section04 : project identity [e]-->
			<section class="project-client">
				<strong class="a11y-hidden">디지털 아카이브</strong>
			</section>
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
.sub-text {
	word-break: keep-all;
}
/*   */
.project-subtit {
	display: block;
	margin-bottom: 10px;
	font-size: 3.3rem;
}
.sub-text {
	line-height: 1.5;
	font-weight: 500;
	margin-top: 5px;
}
.layer-project-detail {
	overflow: hidden;
	background-color: transparent;
}
@media screen and (min-width: 712px) {
	.project-subtit {
		font-size: 3.3rem;
	}
	.information-area {
		padding: 0 40px;
	}
}
@media screen and (min-width: 1280px) {
	.project-subtit {
		font-size: 56px;
	}
	.sub-text {
		font-size: 15px;
		line-height: 28px;
		font-weight: 400;
	}
	.information-area {
		padding: 0;
	}
	.inner-section {
		max-width: 1240px;
		margin: 0 auto;
	}
}
/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/lg-archive/ci.png) 50% / auto
		17.5px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lg-archive/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lg-archive/bg-overview@t.jpg);
	}
	.project-visual br {
		display: none;
	}
	.project-visual .nowrap {
		display: block;
	}
	.project-client {
		background-size: auto 32.5px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lg-archive/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 65px;
	}
}
/* Overview */
.project-overview-txt {
	margin-bottom: 40px;
	font-weight: 400;
	line-height: 1.5;
}
.project-overview-diagram {
	font-weight: 500;
	line-height: 1.7rem;
}
.project-overview-diagram .diagram01 div[class^="item"] {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	width: 140px;
	height: 140px;
	margin: -12.5px -3.5px;
	padding: 4px;
	border-radius: 50%;
	text-align: center;
	background-color: rgba(155, 142, 126, 0.6);
	color: #fff;
}
.project-overview-diagram .diagram01 div.item04 {
	border: 1px solid #9b8e7e;
	color: #857664;
	background-color: transparent;
}
@media screen and (max-width: 711px) {
	.project-overview-txt span {
		display: block;
	}
	.project-overview-diagram {
		max-width: 290px;
		margin: 0 auto;
	}
	.project-overview-diagram .diagram01 {
		margin-bottom: 10px;
		padding-top: 12.5px;
	}
	.project-overview-diagram .diagram01 .item01 {
		justify-content: center;
	}
	.project-overview-diagram .diagram01 .diagram-box {
		display: flex;
		justify-content: space-between;
	}
	.project-overview-diagram .diagram01 .diagram-box:nth-child(1),
	.project-overview-diagram .diagram01 .diagram-box:nth-child(3) {
		justify-content: center;
	}
	.project-overview-diagram .diagram01 .diagram-box:nth-child(2),
	.project-overview-diagram .diagram01 .diagram-box:nth-child(3) {
		margin-top: -20px;
	}
	.project-overview-diagram .diagram01 .item04 {
		margin: 0 auto;
	}
}
@media screen and (min-width: 712px) {
	.project-overview {
		padding-bottom: 50px;
	}
	.project-overview-diagram {
		display: flex;
		justify-content: center;
	}
	.project-overview-diagram .diagram01 {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin-bottom: 0;
		padding-top: 0;
		padding-bottom: 0;
	}
	.project-overview-diagram .diagram01 > div + div {
		margin-left: -8px;
	}
	.project-overview-diagram .diagram01 .diagram-box:nth-child(2) {
		display: flex;
	}
	.project-overview-diagram .diagram01 div .item03 {
		margin-left: -14px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding-bottom: 30px;
	}
	.project-overview-txt span {
		display: block;
	}
	.project-overview-diagram .diagram01 > div,
	.project-overview-diagram .diagram01 div[class^="item"] {
		width: 230px;
		height: 230px;
		font-size: 20px;
	}
	.project-overview-diagram .diagram01 .diagram-box:nth-child(2) {
		width: 450px;
		padding: 20px 0;
	}
	.project-overview-diagram .diagram01 .diagram-box:nth-child(3) {
		padding: 20px 0;
		margin-left: -22px;
	}
	.project-overview-diagram .diagram01 > div {
		border-width: 2px;
		padding: 20px;
		line-height: 1.5;
	}
	.project-overview-diagram .diagram01 > div + div {
		margin-left: 0;
	}
}
.section01 {
	position: relative;
	background: url(/static/img/project-detail/lg-archive/bg-pc-web@m.png)
		no-repeat 50px 92%;
	background-color: #e7e7e7;
	background-size: 100vw;
	padding: 29px 0;
}
.section01 .inner-section {
	padding: 0 15px;
}
.section01 .img-abs {
	position: absolute;
	left: -2.18vw;
	bottom: -38.18vw;
}
@media screen and (max-width: 711px) {
	.section01 .inner-section {
		padding-bottom: 35.18vw;
	}
	.section01 .information-area {
		margin-bottom: 8.59vw;
	}
	.section01 .img-box img {
		border-radius: 3.62vw;
		box-shadow: 0px 22px 22px 0px rgba(0, 0, 0, 0.2);
	}
	.section01 .project-subtit {
		margin: 0;
	}
	.section01 .sub-text br {
		display: none;
	}
	.section01 .img-abs {
		position: absolute;
		left: -2.18vw;
		bottom: -38.18vw;
	}
}
@media screen and (min-width: 712px) {
	.section01 {
		padding: 30px 0;
		background: url(/static/img/project-detail/lg-archive/bg-pc-web@tw.png)
			no-repeat 15vw 88%;
		background-color: #e7e7e7;
		background-size: 82%;
	}
	.layer-project-detail > section.section01 {
		padding-bottom: 35.11vw;
	}
	.section01 .inner-section {
		padding: 0 40px;
	}
	.section01 .information-area {
		width: 100%;
		padding: 0;
	}
	.section01 .img-box {
		margin-top: 3.93vw;
	}
	.section01 .img-box img {
		border-radius: 0.62vw;
		box-shadow: 0px 22px 22px 0px rgba(0, 0, 0, 0.2);
	}
	.section01 .img-abs {
		position: absolute;
		left: 30px;
		bottom: -26.85vw;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > section.section01 {
		padding-bottom: 428px;
	}
	.section01 {
		padding: 65px 0;
		background: url(/static/img/project-detail/lg-archive/bg-pc-web@tw.png)
			no-repeat 540px 88%;
		background-color: #e7e7e7;
		background-size: 68%;
	}
	.section01 .inner-section {
		position: relative;
		padding: 0;
	}
	.section01 .inner-section:after {
		content: "";
		display: block;
		clear: both;
	}
	.section01 .sub-text br {
		display: block;
	}
	.section01 .img-box {
		margin-top: 55px;
		margin-right: -1px;
	}
	.section01 .img-abs {
		position: absolute;
		width: 1605px;
		left: -25px;
		bottom: -820px;
	}
}
.section02 {
	min-height: 81.25vw;
	padding: 0 15px;
}
.section02 .inner-section {
	position: relative;
}
.section02 .img-box {
	position: absolute;
	top: 39.06vw;
	left: 50%;
	margin-left: -44.81vw;
	width: 89.62vw;
	box-shadow: 0px 45px 45px 0px rgba(0, 0, 0, 0.2);
}
@media screen and (min-width: 712px) {
	.section02 {
		min-height: 69.38vw;
		padding: 0 100px;
	}
	.section02 .img-box {
		top: 33.14vw;
		width: 78.65vw;
		margin-left: -39.32vw;
	}
}
@media screen and (min-width: 1280px) {
	.section02 {
		position: relative;
		min-height: 1000px;
	}
	.section02 .img-box {
		top: 580px;
		width: 1120px;
		left: 50%;
		margin-left: -560px;
	}
}
.section03 {
	padding: 0;
	background: url(/static/img/project-detail/lg-archive/bg-pc-web04@m.png)
		no-repeat;
	background-size: 100%;
}
.section03 img {
	width: 100%;
}
@media screen and (max-width: 711px) {
	.layer-project-detail > section.section03 {
		margin-bottom: 5.04vw;
	}
	.section03 {
		padding: 30.16vw 0 0;
	}
}
@media screen and (min-width: 712px) {
	.layer-project-detail > section.section03 {
		margin-bottom: 14.04vw;
	}
	.section03 {
		padding: 26.68vw 0 0;
	}
	.section03 .inner-section {
		position: relative;
		background-size: 29vw;
		background-position: center 8vw;
		padding-left: 30px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 {
		padding: 300px 0 80px;
		height: 1980px;
		background: url(/static/img/project-detail/lg-archive/bg-pc-web04@w.png)
			no-repeat 50% 0;
		background-size: cover 1548px;
	}
	.section03 .inner-section {
		padding: 0 40px;
		max-width: 100%;
	}
	.section03 .img-box {
		position: absolute;
		left: 50%;
		top: 150px;
		margin-left: -759px;
		width: 1518px;
	}
}
.section04 {
	position: relative;
	background-color: #f2f2f2;
	padding: 40px 0;
}
.section04 .inner-section {
	padding: 0 15px;
}
.section04 .log-font-box {
	width: 45.31vw;
}
.section04 .point-font {
	width: 76.56vw;
	margin-top: 30px;
}
.section04 .point-color {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 30px;
}
.section04 .point-color li {
	width: 20.31vw;
	height: 20.31vw;
	border-radius: 50%;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.2em;
}
.section04 .point-color .color01 {
	background-color: #b41131;
}
.section04 .point-color .color02 {
	background-color: #333;
}
.section04 .point-color .color03 {
	background-color: #666;
}
.section04 .point-color .color04 {
	background-color: #474e5a;
}
@media screen and (min-width: 712px) {
	.section04 {
		padding: 80px 0;
	}
	.section04 .inner-section {
		padding: 0 60px;
	}
	.section04 .information-area {
		padding: 0 15px;
	}
	.point-area {
		display: flex;
		justify-content: space-between;
		flex: 1;
	}
	.point-area > div {
		width: 50%;
	}
	.section04 .log-font-box {
		width: 25.91vw;
	}
	.section04 .point-font {
		width: 35.11vw;
		margin-top: 0;
	}
	.section04 .point-color {
		width: 100%;
		margin-top: 40px;
	}
	.section04 .point-color li {
		width: 9.12vw;
		height: 9.12vw;
		text-align: center;
		font-size: 1.3rem;
	}
}
@media screen and (min-width: 1280px) {
	.section04 {
		padding: 160px 0;
	}
	.section04:before {
		left: -50px;
		background: url(/static/img/project-detail/db-life-smart-phone-sales/bg-point-color-and-font@w.png)
			no-repeat;
	}
	.section04 .inner-section {
		padding: 0 20px;
	}
	.section04 .information-area {
		padding: 0;
	}
	.section04 .log-font-box {
		width: 370px;
	}
	.section04 .point-color {
		margin-top: 45px;
	}
	.section04 .point-color li {
		width: 130px;
		height: 130px;
		text-align: center;
		font-size: 18px;
	}
}
</style>


// WEBPACK FOOTER //
// src/projects/lg-archive.vue